import { setOocImagesEnabled } from "../client/oocImages";

/** Settings toggle: show/hide OOC embedded images, re-rendering existing
 *  log entries both ways. */
export function toggleOocImages(checked: boolean) {
  setOocImagesEnabled(checked);
}
window.toggleOocImages = toggleOocImages;
